module.exports = __webpack_public_path__ + "static/mongoDb-icon-50bbea61f1e698ac36f36c055f0c8808.png";